// src/components/web/FloatingButtons/index.jsx
import React from "react";
import { Box, Fab, Badge, Tooltip, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import { useCartContext } from "@/contexts/CartContext";
import Icon from "@/theme/vectors/bundle";
import { ROUTES, CONTACT_INFO } from "@/utils/web/constants";
import { colors } from "@/theme/web-theme";

const FloatingButtons = () => {
    const { t } = useTranslation();
    const { getTotalItems } = useCartContext();
    const theme = useTheme();

    // Xử lý số điện thoại
    const handleCallClick = () => {
        window.location.href = `tel:${CONTACT_INFO.HOTLINE.replace(/\s+/g, "")}`;
    };

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 100,
                right: 20,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                zIndex: theme.zIndex.drawer + 2,
            }}
        >
            {/* Nút giỏ hàng */}
            <Tooltip title={t("common.cart")} placement="left">
                <Fab
                    color="primary"
                    aria-label="cart"
                    component={Link}
                    to={ROUTES.CART}
                    sx={{
                        boxShadow: 3,
                    }}
                >
                    <Badge
                        badgeContent={getTotalItems()}
                        color="error"
                        max={99}
                        overlap="circular"
                    >
                        <Icon name="shoppingCart" size={24} />
                    </Badge>
                </Fab>
            </Tooltip>

            {/* Nút gọi điện thoại */}
            <Tooltip title={t("common.call")} placement="left">
                <a
                    href={`tel:${CONTACT_INFO.HOTLINE.replace(/\s+/g, "")}`}
                    style={{ color: 'inherit', textDecoration: 'none' }}
                >
                    <Fab
                        color="secondary"
                        aria-label="call"
                        sx={{ boxShadow: 3 }}
                    >
                        <Icon name="phone" size={24} color={colors.primary.main} />
                    </Fab>
                </a>
            </Tooltip>
        </Box>
    );
};

export default FloatingButtons;
